import { type EarlyAccessFacilitiesResponse } from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type AxiosError } from "axios";

import {
  earlyAccessFacilitiesResponseSchema,
  type Facility,
  transformFacilitiesResponse,
} from "../data/schemas";

const EARLY_ACCESS_FACILITIES_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/early-access-facilities`;

export function useGetEarlyAccessFacilities(
  options?: UseGetQueryOptions<EarlyAccessFacilitiesResponse, AxiosError, Facility[]>
) {
  return useGetQuery({
    url: EARLY_ACCESS_FACILITIES_URL,
    responseSchema: earlyAccessFacilitiesResponseSchema,
    select: transformFacilitiesResponse,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_EARLY_ACCESS_FACILITIES_FAILURE,
      userErrorMessage: "Something went wrong while loading facilities.",
    },
    ...options,
  });
}
